const LOCAL_DATE_REGEX = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/;

// Convert timestamp to DateTimeLocal format
export function timeStampToDateTimeLocal(timestamp) {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); 
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
}

// Split DateTimeLocal into date and time
export function dateTimeLocalToDateAndTime(dateTimeLocal) {
    const [date, time] = dateTimeLocal.split('T');
    return { date, time };
}

// Convert a date to timestamp (in ms)
export function dateToTimestampMs(dateString) {
    const date = new Date(dateString);
    
    if (isNaN(date.getTime())) {
        console.error("Invalid date format:", dateString);
        return null;
    }

    return date.getTime(); 
}  

// Validate the format of a localDate
export function isValidLocalDate(dateString) {
    if (!LOCAL_DATE_REGEX.test(dateString)) return false;
    const [year, month, day] = dateString.split("T")[0].split("-").map(Number);
    const date = new Date(year, month - 1, day);
    return date.getFullYear() === year && date.getMonth() + 1 === month && date.getDate() === day;
};